// extracted by mini-css-extract-plugin
export default {"noImage":"Image_noImage__Ci9IF"};